<template>
  <div class="careers-page">
    <!-- <div class="container large full">
      <div class="banner-image">
        <img
          class="logo"
          src="../../assets/images/team.jpg"
        >
      </div>
    </div> -->
    <div class="container">
      <el-row>
        <grid-col
          :xs="{span:21, offset:1}"
          :sm="{span:21, offset:1}"
          :md="{span:21, offset:1}"
          :lg="{span:21, offset:1}"
          :xl="{span:21, offset:1}">
          <div class="m-t-3 m-b-3">
            <h3 class="font-normal t-c m-t-0">
              Join our growing team!
            </h3>
            <div
              v-loading="loading"
              style="min-height: 100px"
            >
              <div
                v-for="(department, index) in departments"
                v-if="department.jobs.length"
                :key="index"
                class="department t-l m-b-2"
              >
                <p class="title m-0">
                  {{ department.name }}
                </p>
                <div
                  v-for="(job, index2) in department.jobs"
                  :key="index2"
                >
                  <router-link
                    :to="`/job/${job.id}`"
                    class="job-link m-0"
                    color="primary"
                  >
                    {{ job.title }}
                  </router-link>
                  <p
                    class="m-0 muted"
                    type="info"
                  >
                    {{ job.location ? job.location.name : '' }}
                  </p>
                </div>
              </div>
            </div>
            <p
              v-if="!departments && !loading"
              class="t-c"
            >
              No jobs found.
            </p>
          </div>
        </grid-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Job from '../../services/Job';

export default {
  name: 'Career',
  data() {
    return {
      departments: [],
      jobsProvider: new Job(),
      loading: true,
    };
  },
  mounted() {
    this.getJobsByDepartment();
  },
  methods: {
    getJobsByDepartment() {
      this.jobsProvider.getJobsByDepartment().then((resp) => {
        this.departments = resp.departments || [];
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss">
.careers-page {
  padding-bottom: 52px;

  h3 {
    font-family: "ITC Clearface-bold";
    font-size: 51px;

    @media (max-width: 768px) {
      font-size: 32px;
      line-height: 35px;
    }
  }
  .department {
    .title{
      color: black;
      font-family: Favorit;
      font-size: 16px;
      font-weight: 700;
      line-height: 30px;
    }
  }

  .job-link {
    line-height: 30px;
  }

  .muted{
    color: #666;
    line-height: 30px;
  }
  .banner-image {
    width: 100%;

    img {
     width:100%;
     max-width:100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/careers/Careers.vue